export enum MessageType {
    SMS,
    EMAIL,
}
